module.exports = __webpack_public_path__ + "img/salon_thumbnail.cb9168af.jpg";